var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor send-sms" }, [
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "title" }, [_vm._v("SMS Provider")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c(
            "a-select",
            {
              attrs: { defaultValue: null },
              model: {
                value: _vm.clone.channelId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "channelId", $$v)
                },
                expression: "clone.channelId",
              },
            },
            [
              _c(
                "a-select-option",
                { attrs: { selected: true, value: "null" } },
                [_vm._v("👉Select SMS Provider...")]
              ),
              _vm._v(" "),
              _vm._l(_vm.smsChannels, function (channel) {
                return _c(
                  "a-select-option",
                  { key: channel._id, attrs: { value: channel._id } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(channel.name) +
                        "\n                "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Sender ID")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c(
            "a-select",
            {
              attrs: { defaultValue: null },
              model: {
                value: _vm.clone.senderId,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "senderId", $$v)
                },
                expression: "clone.senderId",
              },
            },
            [
              _c(
                "a-select-option",
                { attrs: { selected: true, value: "PSTCELLTEST" } },
                [_vm._v("PSTCELLTEST")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Phone Number")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Phone Number",
              "show-attributes": true,
              "show-emoji": false,
            },
            model: {
              value: _vm.clone.number,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "number", $$v)
              },
              expression: "clone.number",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { staticClass: "title" }, [_vm._v("Message")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-editor-wrapper" },
        [
          _c("TiptapEditor", {
            attrs: {
              placeholder: "Mesajınızı Buraya Yazın.",
              "show-attributes": true,
              "show-emoji": false,
              "max-character-count": 160,
            },
            model: {
              value: _vm.clone.message,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "message", $$v)
              },
              expression: "clone.message",
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }